export default {
	saveUser(state, users) {
		state.user = users
	},
	setShop(state, data) {
		state.shopID = data.shopID;
	},
	refresh(state, data) {
		state.area = data.area;
		state.shop = data.shop;
		state.CategoryMenu = data.CategoryMen;
		state.Writer = data.writer;
		state.Classification = data.Classification;
		for (let i of state.shop) {
			if (i.ShopID == state.shopID) {
				state.shopName = i.ShopName;
				break;
			}
		}
		data.Transporter.unshift({
			UserName: "请选择",
			UserID: 0,
			UserPhone: '',

		});

		state.Transporter = data.Transporter;
	},
	setSubjects(state, data) {
		state.Subjects = data;
	},
	saveUrl(s, r) {

		s.baseURL = r.baseURL + '/api/';
		s.imageUrlCustomerCode = r.baseURL + r.imageUrlCustomerCode;
		s.imageUrl = r.baseURL + r.imageUrl;
        s.logoUrl = r.baseURL + r.logoUrl;
	}

}
